/* import __COLOCATED_TEMPLATE__ from './workspace-security.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type Store from '@ember-data/store';
import { tracked } from 'tracked-built-ins';
import { isValidEmail } from 'embercom/lib/email';
import { SAML_PROVISIONING_METHODS } from 'embercom/controllers/apps/app/settings/workspace/security';
import { action } from '@ember/object';

export interface WorkspaceSecurityArgs {
  settings: $TSFixMe;
  initialProvisioningMethod: string;
  selectedProvisioningMethod: string;
  showAllErrors: boolean;
}

export interface Signature {
  Element: HTMLDivElement;
  Args: WorkspaceSecurityArgs;
}

export default class WorkspaceSecurity extends Component<Signature> {
  @service declare appService: $TSFixMe;
  @service declare notificationsService: $TSFixMe;
  @service declare intl: IntlService;
  @service declare store: Store;
  @service declare intercomEventService: $TSFixMe;
  @service declare securityAppSettingsService: $TSFixMe;
  @service declare modalService: $TSFixMe;

  @tracked showEnforceSamlModal = false;
  @tracked showSamlVerificationModal = false;
  @tracked showAllErrors = false;
  @tracked showEnforceSsoModal = false;
  @tracked showEnforce2faModal = false;
  @tracked initialProvisioningMethod = this.args.initialProvisioningMethod;
  @tracked selectedProvisioningMethod = this.args.selectedProvisioningMethod;

  get app() {
    return this.appService.app;
  }

  get samlAccount() {
    return this.args.settings.samlAccount;
  }

  get isInvalidSecurityEmail() {
    if (
      this.args.settings.securityContactEmail === '' ||
      this.args.settings.securityContactEmail === null
    ) {
      return false;
    }
    return !isValidEmail(this.args.settings.securityContactEmail);
  }

  get hasChangedProvisioningMethod() {
    return this.initialProvisioningMethod !== this.selectedProvisioningMethod;
  }

  get scimEnabled() {
    return this.selectedProvisioningMethod === SAML_PROVISIONING_METHODS.scim;
  }

  get canEnforceSSO() {
    return this.args.settings.canEnableEnforceSso;
  }

  get canEnforceSaml() {
    return this.args.settings.canEnforceSaml;
  }

  get hasEnabled2fa() {
    return this.app.currentAdmin.has_enabled_2fa;
  }

  get shouldShowSecurityContactWarningIcon() {
    if (
      this.args.settings.hasDirtyAttributes &&
      this.args.settings.changedAttributes().securityContactEmail
    ) {
      return this.args.settings.changedAttributes().securityContactEmail[0] === '';
    }
    return this.args.settings.securityContactEmail === '';
  }

  @action
  updateProvisioningMethod(selectedProvisioningMethod: string) {
    this.selectedProvisioningMethod = selectedProvisioningMethod;

    if (selectedProvisioningMethod === 'scim' && !this.args.settings.scimSettings) {
      this.args.settings.set(
        'scimSettings',
        this.store.createRecord('scim-setting', {
          immuneAdminIds: [],
          scimEndpointUrl: `https://api.intercom.io/scim/v2/${this.app.id}`,
        }),
      );
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Security::Tabs::WorkspaceSecurity': typeof WorkspaceSecurity;
    'new-settings/workspace/security/tabs/workspace-security': typeof WorkspaceSecurity;
  }
}
